<template>
  <div class="avatar">
    {{ initials }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  firstName: {
    type: String,
    default: ''
  },
  lastName: {
    type: String,
    default: ''
  }
})

const initials = computed(() => {
  const first = props.firstName.trim().charAt(0)
  const last = props.lastName.trim().charAt(0)

  return `${first}${last}`.toUpperCase()
})
</script>

<style scoped lang="scss">
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: beige;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  user-select: none;
}
</style>